import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { DefaultComponent } from "../../../app/theme/pages/default/default.component";
import { LayoutModule } from "../../../app/theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../../app/freightconfirmation/app.sharemodule";
import { appService } from "../../../app/_services/app.service";
import { CommonService } from "../../../app/_services/common.service";
import { NgxBarcodeModule } from "ngx-barcode";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule, TranslateService, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { VahanComponent } from "./vahan.component";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

// const routes: Routes = [
//     {
//         path: "",
//         component: DefaultComponent,
//         children: [
//             {
//                 path: "",
//                 component: EWayBillComponent,
//             },
//         ],
//     },
// ];

@NgModule({
    imports: [
        CommonModule,
        //RouterModule.forChild(routes),
        LayoutModule,
        FormsModule,
        SharedModule,
        NgxBarcodeModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    exports: [VahanComponent, RouterModule],
    declarations: [VahanComponent],
    providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class VahanModule { }